import styled from 'styled-components';

import { BaseButton } from './BaseButton';

export const RightButton = styled(BaseButton)`
    bottom: 0;
    right: 0;
    transform: rotate(180deg);
`;
